import React from "react";

export function fetchTeasers(
  nids,
  setLoading,
  setLoadingExtra,
  itemOffset,
  teasers,
  language,
  itemsPerPage,
  entitiesPromoted,
  entityViewMode,
  setTeasers,
) {
  if (nids && nids.length) {
    setLoadingExtra(true);

    let unusedNids = [];

    nids.forEach(function (item, index) {
      if (!teasers[item]) {
        unusedNids.push(item);
      }
    });

    fetch(
      "/filter-api/teaser?view_mode=" + entityViewMode + "&lang=" + language,
      {
        credentials: "include",
        method: "POST",
        body: JSON.stringify(unusedNids),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setLoadingExtra(false);

        Object.keys(data).forEach((key) => {
          teasers[key] = data[key];
        });

        setTeasers({ ...teasers });
      });
  }
}
